import { CrudEndpoint } from '@/api/common/CrudEndpoint';
import { ProductCategoryAttributeDTO } from '@/api/dto/ProductCategoryAttributeDTO';

export class ProductCategoryAttributesCRUD extends CrudEndpoint<
  ProductCategoryAttributeDTO
> {
  constructor() {
    super('productcategoryattribute');
  }
}
